module.exports = __webpack_public_path__ + "img/ideation-1_jp.1c27c08.jpg";